<template>
  <power-bi code="eyJrIjoiMzFjMmE0NWQtNGRjNy00OWEwLWJhOTMtYjJiNjA4N2FmZmUxIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
